import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { urls } from 'helpers/url';
import StoreType from 'types/store';

const formatParams = store =>
  (`${store.address || ''}%2C%+${store.city || ''}%2C+${store.state || ''}+${store.zip_code || ''}`)
    .replace(/\s+/g, '+');

const StoreInfo = ({ store, linkToMaps }) => <Fragment>
  {linkToMaps ? (<a
    href={`https://www.google.com/maps/search/?api=1&query=${formatParams(store)}`}
    target="_blank"
    rel="noopener noreferrer"
  >#{store.number}<br />{store.name}</a>) : (<Link to={urls.store(store)}>
    #{store.number}<br />{store.name}
  </Link>)}
</Fragment>;

StoreInfo.defaultProps = { linkToMaps: false };

StoreInfo.propTypes = { store: StoreType.isRequired, linkToMaps: PropTypes.bool };

export default StoreInfo;



// WEBPACK FOOTER //
// ./client/app/shared/components/StoreInfo/index.jsx